/**
 * Created by Ivan on 09.10.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    EARN: {
        MERGE2_MISSION: "merge2mission"
    },

    MERGE2_MISSION_STACK_EMPTY: "merge2mission_stack_empty",
    MERGE2_MISSION_MERGES: "merge2mission_merges"
});
